var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    "data-name": "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Initiator",
    className: "cls-1",
    d: "M600,350c0-138.07-111.93-250-250-250S100,211.93,100,350c0,117.24,80.72,215.62,189.61,242.64V426.4H238.05V350h51.56V317.08c0-85.09,38.5-124.53,122-124.53,15.84,0,43.17,3.1,54.35,6.21V268c-5.9-.62-16.15-.93-28.88-.93-41,0-56.83,15.53-56.83,55.9v27H462l-14,76.4H380.29V598.17C504.07,583.22,600,477.82,600,350Z",
    transform: "translate(-100 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-2",
    d: "M447.92,426.4,462,350H380.29V323c0-40.37,15.84-55.9,56.83-55.9,12.73,0,23,.31,28.88.93V198.76c-11.18-3.11-38.51-6.21-54.35-6.21-83.54,0-122,39.44-122,124.53V350H238.05v76.4h51.56V592.64a251.49,251.49,0,0,0,90.68,5.53V426.4Z",
    transform: "translate(-100 -100)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Facebook_Logo.c144f1a226261e250fe1867c164af821.svg";